module.exports = __webpack_public_path__ + "static/media/resume.7c9a39ae.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resume.pdf
// module id = 346
// module chunks = 0